module.exports = __webpack_public_path__ + "static/media/liquid@3x.afb642c5.png";